import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { GlobalService } from '../services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-transformer-efficiency-cal',
  templateUrl: './transformer-efficiency-cal.component.html',
  styleUrls: ['./transformer-efficiency-cal.component.scss']
})
export class TransformerEfficiencyCalComponent implements OnInit {

  resistanceMilliohm: number = 0.03;
  ironLossWatts: number = 1875;
  strayLossPercent: number = 7;
  readings: Array<{
    id: string;
    label: string;
    timestamp: Date;
    vRY?: number; vYB?: number; vBR?: number;
    iL1?: number; iL2?: number; iL3?: number;
    pf?: number;
    vLineAvg?: number; iAvg?: number;
    outputPowerKW?: number;
    efficiencyPercent?: number;
    copperLossKW?: number;
    strayLossKW?: number;
    totalLossKW?: number;
    finalTotalLossKW?: number;
    lf?:any
  }> = [];
  selectedReadingId: string | null = null;
  currentUserData = JSON.parse(localStorage.getItem('userData'));
  inputPowerKW = 0;
  outputPowerKW = 0;
  copperLossKW = 0;
  ironLossKW = 0;
  strayLossKW = 0;
  totalLossKW = 0;

  efficiencyPercent = 0;
  selectedTransformer_E = null;
  transformerList_E = [];
  filterresultData: any = [];
  isLoading = false;

  public mainChartData = [];
  public lossChartData = [];

  public mainChart = {
    layout: {
      autosize: true,
      margin: { l: 25, r: 25, t: 10, b: 25 },
      xaxis: {
        title: 'Time',
        font: { size: 7 },
        showgrid: true,
        gridwidth: 1,
        gridcolor: '#e5e7eb',
        automargin: true
      },
      yaxis: {
        title: 'Power (kW)',
        font: { size: 7 },
        showgrid: true,
        gridwidth: 1,
        gridcolor: '#e5e7eb',
        automargin: true
      },
      yaxis2: {
        title: 'Efficiency (%)',
        overlaying: 'y',
        side: 'right',
        font: { size: 7 },
        showgrid: false,
        automargin: true
      },
      legend: {
        x: 0,
        y: 1,
        bgcolor: 'rgba(255,255,255,0.9)',
        bordercolor: 'rgba(0,0,0,0.2)',
        borderwidth: 1,
        font: { size: 7 },
        orientation: 'h'
      },
      plot_bgcolor: 'rgba(0,0,0,0)',
      paper_bgcolor: 'rgba(0,0,0,0)',
      height: undefined
    },
    config: {
      displayModeBar: true,
      modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines'],
      displaylogo: false,
      responsive: true,
      toImageButtonOptions: {
        format: 'png',
        filename: 'transformer_efficiency_chart',
        height: '100%',
        width: 700,
        scale: 1
      }
    }
  };

  public lossChart = {
    layout: {
      autosize: true,   // 🔥 resize with container
      margin: { l: 25, r: 25, t: 20, b: 35 },
      xaxis: {
        title: { text: 'Time', standoff: 10 },
        tickfont: { size: 10 },
        showgrid: true,
        gridwidth: 1,
        gridcolor: '#e5e7eb',
        automargin: true
      },
      yaxis: {
        title: { text: 'Loss (kW)', standoff: 10 },
        tickfont: { size: 10 },
        showgrid: true,
        gridwidth: 1,
        gridcolor: '#e5e7eb',
        automargin: true
      },
      legend: {
        x: 0,
        y: 1,
        bgcolor: 'rgba(255,255,255,0.9)',
        bordercolor: 'rgba(0,0,0,0.2)',
        borderwidth: 1,
        font: { size: 9 },
        orientation: 'h'
      },
      plot_bgcolor: 'rgba(0,0,0,0)',
      paper_bgcolor: 'rgba(0,0,0,0)'
    },
    config: {
      responsive: true, // 🔥 key for responsiveness
      displayModeBar: true,
      displaylogo: false,
      modeBarButtonsToRemove: [
        'zoom2d',
        'pan2d',
        'select2d',
        'lasso2d',
        'toggleSpikelines'
      ],
      toImageButtonOptions: {
        format: 'png',
        filename: 'transformer_loss_chart',
        scale: 1
      }
    }
  };
  
  
  constructor(private globalService: GlobalService, private router: Router, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.selectedReadingId = this.readings.length > 0 ? this.readings[0].id : null;
    this.recalculate();
    this.gettransformerId();
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.updateCharts();
      }, 100);
    });
  }

  onTransformerChange(selected: any) {
    this.selectedTransformer_E = selected;
    if (selected && selected.transformerid) {
      this.isLoading = true;
      const deviceData = this.filterresultData.find(
        (item: any) => item.transformerid === selected.transformerid
      );
      this.globalService.getTransformerReading(selected.transformerid).subscribe({
        next: (res: any) => {
          console.log('Transformer reading response:', res);
          if (res.exists) {
            this.resistanceMilliohm = res.data.resistance;
            this.ironLossWatts = res.data.ironLossWatts;
            this.strayLossPercent = res.data.strayLoss;
          }
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error fetching transformer reading:', err);
          this.isLoading = false;
        }
      });
      if (deviceData && deviceData.deviceId) {
        this.getdata(deviceData.deviceId);
      } else {
        console.warn('No device found for this transformer.');
        this.isLoading = false;
      }
    }
  }

  getdata(id) {
    this.globalService.getEfficiencyData(id).subscribe(async (response: any) => {
      console.log("efficiency data", response);
      this.loadFromJson(response);
      this.recalculate();
      this.isLoading = false;

      setTimeout(() => {
        this.updateCharts();
      }, 100);
    }, (error) => {
      console.error("Error loading efficiency data:", error);
      this.isLoading = false;
    });
  }
  gettransformerId() {
    let payloadtogetTransformer = {
      "countryid": null,
      "stateid": null,
      "cityid": null,
      "zoneid": null,
      "locationid": null,
      "transformerid": null,
    }
    this.globalService.getfilteredTransformers(JSON.stringify(payloadtogetTransformer), localStorage.getItem('userData')).subscribe(async (response: any) => {
      this.filterresultData = response.result;
      console.log("adsddsdsd",this.currentUserData)
      if (this.currentUserData.roleid != 1) {
        this.filterresultData = this.filterresultData.filter((item: any) => item.amc_status == "Active");
        if (this.filterresultData.length == 0) {
          this.router.navigate(['/dashboard'])
        }
      }
      this.selectedTransformer_E = this.filterresultData[0];
      this.transformerList_E = this.filterresultData.map((a: any) => {
        a.transformerDetail = a.transformerid + "[" + a.sitename + "]";
        return a;
      })
      this.onTransformerChange(this.selectedTransformer_E);
    });
  }

  get selectedReading() {
    const found = this.readings.find(r => r.id === this.selectedReadingId);
    return found || null;
  }

  getReversedReadings() {
    return this.readings.slice().reverse();
  }

  selectReading(id: string) {
    this.selectedReadingId = id;
    this.recalculate();
  }

  onInputsChanged() {
    this.recalculate();
    setTimeout(() => {
      this.updateCharts();
    }, 100);
  }

  loadFromJson(rows: any[]) {
    console.log("loading from json", rows);
    this.readings = [];
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const parseNum = (v: any) => {
        if (v === null || v === undefined) return 0;
        const s = String(v).replace(/'/g, '').trim();
        const n = parseFloat(s);
        return isNaN(n) ? 0 : n;
      };
      const parseDate = (v: any) => {
        const s = String(v).replace(/'/g, '').trim();
        const d = new Date(s);
        return isNaN(d.getTime()) ? new Date() : d;
      };
      const vRY = parseNum(row.RY_Voltage);
      const vYB = parseNum(row.YB_Voltage);
      const vBR = parseNum(row.BR_Voltage);
      const iL1 = parseNum(row.L1);
      const iL2 = parseNum(row.L2);
      const iL3 = parseNum(row.L3);
      const pf = Math.abs(parseNum(row.Avg_Power_Factor));
      const ts = parseDate(row.Date);
      const vLineAvg = (vRY + vYB + vBR) / 3;
      const iAvg = (iL1 + iL2 + iL3) / 3;
      let lf = Number((iAvg / row.ratedLoad)*100).toFixed(2);
      this.readings.push({
        id: 'J' + (i + 1),
        label: 'Reading ' + (i + 1),
        timestamp: ts,
        vRY, vYB, vBR,
        iL1, iL2, iL3,
        pf,
        vLineAvg,
        iAvg,
        lf:lf
      });
    }
  }

  computeResultsFromMeasured(vLineAvg: number, iAvg: number, pf: number) {
    const outputKW = Math.sqrt(3) * vLineAvg * iAvg * pf / 1000;
    const rOhmPerPhase = this.resistanceMilliohm / 1000;
    const copperKW = (3 * iAvg * iAvg * rOhmPerPhase);
    const ironKW = Math.max(this.ironLossWatts, 0) / 1000;
    const totalKW = copperKW + ironKW;
    const strayKW = Math.max(this.strayLossPercent, 0) * totalKW / 100;
    const inputKW = outputKW + totalKW + strayKW;
    const eff = inputKW > 0 ? (outputKW / inputKW) * 100 : 0;

    return {
      outputKW,
      copperKW,
      ironKW,
      strayKW,
      totalKW,
      inputKW,
      eff
    };
  }

  recalculate() {
    for (let i = 0; i < this.readings.length; i++) {
      const r = this.readings[i];
      const v = r.vLineAvg || 0;
      const ia = r.iAvg || 0;
      const pf = (r.pf === undefined || r.pf === null) ? 0 : r.pf;
      const rr = this.computeResultsFromMeasured(v, ia, pf);
      r.outputPowerKW = rr.outputKW;
      r.efficiencyPercent = rr.eff;
      r.copperLossKW = rr.copperKW;
      r.strayLossKW = rr.strayKW;
      r.totalLossKW = rr.totalKW;
      r.finalTotalLossKW = r.totalLossKW + r.strayLossKW;
    }
    const sr = this.selectedReading;
    if (!sr) {
      this.resetResults();
      return;
    }
    const res = this.computeResultsFromMeasured(sr.vLineAvg || 0, sr.iAvg || 0, sr.pf || 0);
    this.outputPowerKW = res.outputKW;
    this.copperLossKW = res.copperKW;
    this.ironLossKW = res.ironKW;
    this.strayLossKW = res.strayKW;
    this.totalLossKW = res.totalKW;
    this.inputPowerKW = res.inputKW;
    this.efficiencyPercent = res.eff;
    this.updateCharts();
  }

  updateCharts() {
    this.createMainChart();
    this.createLossChart();
  }

  createMainChart() {
    if (!this.readings || this.readings.length === 0) return;

    const time = this.readings.map(r => r.timestamp);
    const outputPower = this.readings.map(r => r.outputPowerKW || 0);
    const efficiency = this.readings.map(r => r.efficiencyPercent || 0);

    this.mainChartData = [
      {
        x: time,
        y: outputPower,
        type: 'scatter',
        mode: 'lines+markers',
        name: 'Output (kW)',
        line: { color: '#3b82f6', width: 3 },
        marker: { size: 6 }
      },
      {
        x: time,
        y: efficiency,
        type: 'scatter',
        mode: 'lines+markers',
        name: 'Efficiency (%)',
        yaxis: 'y2',
        line: { color: '#0ea5e9', width: 3, dash: 'dash' },
        marker: { size: 6 }
      }
    ];
  }

  createLossChart() {
    if (!this.readings || this.readings.length === 0) return;
    const time = this.readings.map(r => r.timestamp);
    const copperLoss = this.readings.map(r => r.copperLossKW || 0);
    const strayLoss = this.readings.map(r => r.strayLossKW || 0);
    const totalLoss = this.readings.map(r => r.totalLossKW || 0);
    const finalTotalLoss = this.readings.map(r => r.finalTotalLossKW || 0);

    this.lossChartData = [
      {
        x: time,
        y: copperLoss,
        type: 'scatter',
        mode: 'lines+markers',
        name: 'Copper (kW)',
        line: { color: '#ef4444', width: 3 },
        marker: { size: 6 }
      },
      {
        x: time,
        y: strayLoss,
        type: 'scatter',
        mode: 'lines+markers',
        name: 'Stray (kW)',
        line: { color: '#10b981', width: 3 },
        marker: { size: 6 }
      },
      {
        x: time,
        y: totalLoss,
        type: 'scatter',
        mode: 'lines+markers',
        name: 'Total Loss (kW)',
        line: { color: '#f59e0b', width: 3 },
        marker: { size: 6 }
      },
      {
        x: time,
        y: finalTotalLoss,
        type: 'scatter',
        mode: 'lines+markers',
        name: 'Final Total Loss (kW)',
        line: { color: '#8b5cf6', width: 3 },
        marker: { size: 6 }
      }
    ];
  }

  resetResults() {
    this.inputPowerKW = 0;
    this.outputPowerKW = 0;
    this.copperLossKW = 0;
    this.ironLossKW = 0;
    this.strayLossKW = 0;
    this.totalLossKW = 0;
    this.efficiencyPercent = 0;
  }

  formatTime(d: Date): string {
    const hh = d.getHours().toString().padStart(2, '0');
    const mm = d.getMinutes().toString().padStart(2, '0');
    return hh + ':' + mm;
  }

  saveReadings(transformerid: string, resistance: number, ironLossWatts: number, strayLoss: number) {
    const payload = {
      transformerid,
      resistance,
      ironLossWatts,
      strayLoss
    };

    console.log('Saving readings:', payload);

    // Call the API via service
    this.globalService.saveTransformerReadings(payload).subscribe({
      next: (res: any) => {
        console.log('API response:', res);
        this.snackBar.open(res && res.message ? res.message : 'Saved successfully', 'OK', {
          duration: 2500,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['snack-success']
        });
      },
      error: (err) => {
        console.error('Error saving readings:', err);
        this.snackBar.open('Error saving readings', 'Dismiss', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['snack-error']
        });
      }
    });
  }


  downloadReport() {
    try {
      const lines: string[] = [];
      const transformerName = (this.selectedTransformer_E && (this.selectedTransformer_E.transformerDetail || this.selectedTransformer_E.transformerid)) || 'Transformer';

      lines.push('Transformer,Resistance (mOhm),Iron Loss (W),Stray Loss (%),Generated At');
      lines.push([
        `"${transformerName}"`,
        this.resistanceMilliohm,
        this.ironLossWatts,
        this.strayLossPercent,
        new Date().toISOString()
      ].join(','));
      lines.push('');

      lines.push('Time,Copper (kW),Stray (kW),Total Loss (kW),Final Loss (kW),Output (kW),Efficiency (%)');

      const rows = this.getReversedReadings();
      for (const r of rows) {
        const timeStr = r.timestamp ? this.formatTime(new Date(r.timestamp)) : '';
        const row = [
          timeStr,
          ((r.copperLossKW != null ? r.copperLossKW : 0).toFixed(1)),
          ((r.strayLossKW != null ? r.strayLossKW : 0).toFixed(1)),
          ((r.totalLossKW != null ? r.totalLossKW : 0).toFixed(1)),
          ((r.finalTotalLossKW != null ? r.finalTotalLossKW : 0).toFixed(1)),
          ((r.outputPowerKW != null ? r.outputPowerKW : 0).toFixed(0)),
          ((r.efficiencyPercent != null ? r.efficiencyPercent : 0).toFixed(1))
        ].join(',');
        lines.push(row);
      }

      const csvContent = lines.join('\r\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const fileName = `transformer_report_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.csv`;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Failed to generate report:', err);
      this.snackBar.open('Failed to download report', 'Dismiss', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['snack-error']
      });
    }
  }


}
